import styled from 'styled-components';
import { rem, themed } from '@/shared/ui/core';

export const RadioGroup = styled.div.attrs({
  className: 'RadioGroup',
})`
  display: flex;
  margin-bottom: 1rem;
  margin-top: 1rem;

  @media(max-width: 375px) {
    flex-direction: column;
    margin-top: 0.25rem;

    label.RadioLabel {
      margin: 0.75rem 0 0;
    }
  }
`;

export const RadioLabel = styled.label.attrs({
  className: 'RadioLabel',
})`
  & + .RadioLabel {
    margin-left: 1.5rem;
  }
`;

export const RadioInput = styled.input.attrs({
  type: 'radio',
})`
  &:focus + span {
    text-decoration: underline;
  }
`;

export const RadioLabelText = styled.span`
  display: inline-block;
  font-size: ${themed('input.fontSize', rem)};
  height: 1.5rem;
  line-height: 1.8rem;
  padding-left: 2rem;
  position: relative;

  &::before {
    border: 2px solid;
    border-color: ${({ $checked, theme }) => $checked ? theme.primary.accent : theme.primary.darkGray};
    border-radius: 50%;
    content: '';
    left: 0;
    height: 1.25rem;
    position: absolute;
    width: 1.25rem;

    transition: all 200ms ease;
  }

  &::after {
    background-color: ${themed('primary.accent')};
    border-radius: 50%;
    content: '';
    left: 0.25rem;
    height: 1rem;
    position: absolute;
    opacity: ${({ $checked }) => $checked ? 1 : 0};
    top: 0.25rem;
    width: 1rem;

    transition: all 200ms ease;
  }
`;
